<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main v-if="!isNil(data)" class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('pagePaymentRequest.title') }} #{{ data.id | id2number }}
    </portal>
    <card :title="$t('pagePaymentRequest.card.paymentRequest')" cols="12 6@desktop 4@hd" rows="2">
      <hm-card-inner :title="$t('pagePaymentRequest.card.general')">
        <hm-input :value="$t(`PaymentRequestStatus.${data.status}`)"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.status')"
                  cols="12"
                  name="status" />
        <hm-input v-if="!isNil(data.cancellationReason)"
                  :value="$t(`PaymentRequestCancellationReason.${data.cancellationReason}`)"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.cancellationReason')"
                  cols="12"
                  name="cancellationReason" />
        <hm-input :value="$t(`PaymentRequestType.${data.type}`)"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.type')"
                  cols="12"
                  name="type" />
        <hm-input :value="data.setupType"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.paymentType')"
                  cols="12"
                  name="setupType" />
        <hm-input-money v-model="data.amount"
                        :currency="data.currency"
                        :disabled="true"
                        :label="$t('pagePaymentRequest.amount')"
                        name="amount" />
        <hm-input :value="data.createdAt | toLocalDateTime"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.createdAt')"
                  cols="12"
                  name="createdAt" />
        <hm-input v-if="!['Complete','Failed','Cancelled'].includes(data.status)"
                  :value="data.expireAt | toLocalDateTime"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.expireAt')"
                  cols="12"
                  name="expireAt" />
        <hm-input v-if="!isEmpty(data.url)"
                  :value="data.url"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.url')"
                  cols="12"
                  name="url">
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button :border="true" :title="$t('pagePaymentRequest.copyToClipboard')" icon="copy" @click="$copy(data.url)" />
          </template>
        </hm-input>
      </hm-card-inner>
      <hm-card-inner :title="$t('pagePaymentRequest.card.guest')">
        <hm-input :value="data.email"
                  :disabled="true"
                  :label="$t('pagePaymentRequest.email')"
                  cols="12"
                  name="email" />
        <guest-search ref="guestSearch" v-model="data.guestProfileId" :disabled="true" :label="$t('pagePaymentRequest.guestProfile')"/>
      </hm-card-inner>
      <hm-card-inner :title="$t('pagePaymentRequest.card.psp')">
        <hm-input :value="data.psp"
                  :disabled="true"
                  label="PSP"
                  cols="12"
                  name="psp" />
        <hm-input-link v-if="!isEmpty(data.pspCustomerId)"
                       :value="data.pspCustomerId"
                       :disabled="true"
                       :url="getPspCustomerLink()"
                       :label="$t('pagePaymentRequest.pspCustomerLink')"
                       cols="12"
                       name="pspCustomerId" />
      </hm-card-inner>
      <hm-card-inner v-if="hasRole('ROLE_SYSADMIN')" :title="$t('pagePaymentRequest.card.pspAdditionalInformation')">
        <template v-for="(additionalField, idx) in data.refKeys">
          <hm-input :value="additionalField.value"
                    :key="idx"
                    :disabled="true"
                    :label="additionalField.key"
                    cols="12" />
        </template>
      </hm-card-inner>
    </card>
    <card :title="$t('pagePaymentRequest.card.reservations')" cols="12 6@desktop 4@hd">
      <hm-card-inner :full-size="true">
        <hm-table :hover="true"
                  :sticky="true"
                  columns="2"
                  grid-template-columns="auto minmax(12rem, max-content)"
                  min-width="40rem">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('pagePaymentRequest.table.reservationId') }}</div>
            <div class="hm-table__th text-right">{{ $t('pagePaymentRequest.table.reservationAmount') }}</div>
          </template>
          <template v-for="row in data.folioPaymentDetails">
            <div class="hm-table__td" @click="openEntity(row.folioIdentifier.parentId)">{{ $t(`EntityType.${row.folioIdentifier.parentId.type}`) }} #{{ row.folioIdentifier.parentId.id | id2number }}</div>
            <div class="hm-table__td text-right" @click="openEntity(row.folioIdentifier.parentId)">{{ row.amount | toCurrency }}&nbsp;{{ row.currency }}</div>
          </template>
        </hm-table>
      </hm-card-inner>
    </card>
    <card :title="$t('pagePaymentRequest.card.pspPayments')" cols="12 6@desktop 4@hd start-5@hd">
      <hm-card-inner :full-size="true">
        <hm-table :hover="['Mollie','Stripe'].includes(data.psp)"
                  :sticky="true"
                  columns="2"
                  min-width="40rem">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('pagePaymentRequest.table.pspPaymentId') }}</div>
            <div class="hm-table__th text-right">{{ $t('pagePaymentRequest.table.pspPaymentStatus') }}</div>
          </template>
          <template v-for="row in data.pspPaymentRequests">
            <div :class="[{ 'hm-table__td--no-hover': data.psp === 'Stripe' && (isEmpty(row.additionalFields) || isEmpty(row.additionalFields.STRIPE_PAYMENT_INTENT_ID)) }]" class="hm-table__td" @click="openPspPayment(row)">{{ row.externalPaymentId }}</div>
            <div :class="[{ 'hm-table__td--no-hover': data.psp === 'Stripe' && (isEmpty(row.additionalFields) || isEmpty(row.additionalFields.STRIPE_PAYMENT_INTENT_ID)) }]" class="hm-table__td text-right">{{ row.status }}</div>
          </template>
        </hm-table>
      </hm-card-inner>
    </card>

    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button v-if="['Deposit','FolioBalance'].includes(data.type) && ['Initial'].includes(data.status)"
                          :label="$t('pagePaymentRequest.actions.cancelPaymentRequest')"
                          icon="close"
                          color="red"
                          @click="cancelPaymentRequest()"/>
      <hm-floating-button v-if="['Deposit'].includes(data.type) && ['Initial'].includes(data.status) && ['Manual'].includes(data.psp)"
                          :label="$t('pagePaymentRequest.actions.markAsPaid')"
                          icon="cash"
                          color="green"
                          @click="markAsPaid()"/>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  get,
  filter,
  last,
  find,
  nth,
  template,
  clone,
  cloneDeep,
  isEqual,
  isObject,
  debounce,
  lowerCase,
  head,
} from 'lodash';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmInputMoney from '../../lib/inputs/HmInputMoney';
import HmInput from '../../lib/inputs/HmInput';
import HmTable from '../../lib/table/HmTable';
import { isProduction } from '@/lib/util/isProduction';

export default {
  name: 'PageHotelInquiry',
  components: { HmTable, HmInput, HmInputMoney, HmCardInner },
  mixins: [HotelmeisterMixin],

  data() {
    return {
      paymentRequestId: null,
      data: null,
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    this.paymentRequestId = this.$route.params.paymentRequestId;
    this.updateData();
  },

  methods: {
    updateData: function () {
      this.axios.get(this.serviceUrls.paymentRequest.get(this, this.paymentRequestId)).then((response) => {
        this.data = response.data.data;
      });
    },
    getPspCustomerLink() {
      switch (this.data.psp) {
        case 'Stripe':
          if (isProduction) {
            return `https://dashboard.stripe.com/customers/${this.data.pspCustomerId}`;
          } else {
            return `https://dashboard.stripe.com/test/customers/${this.data.pspCustomerId}`;
          }
        case 'Mollie':
          return null;
        default:
          return null;
      }
    },

    openEntity: function (parentId) {
      const entityType = parentId.type;
      const id = parentId.id;
      if (entityType === 'RoomReservation') {
        this.$router.push({ name: 'reservation', params: { reservationId: id } });
      } else if (entityType === 'GuestProfile') {
        this.$router.push({ name: 'guest', params: { guestProfileId: id } });
      }
    },
    openPspPayment(pspPayment) {
      switch (this.data.psp) {
        case 'Stripe':
          if (isEmpty(pspPayment.additionalFields) || isEmpty(pspPayment.additionalFields.STRIPE_PAYMENT_INTENT_ID)) return;

          if (isProduction) {
            window.open(`https://dashboard.stripe.com/payments/${pspPayment.additionalFields.STRIPE_PAYMENT_INTENT_ID}`, '_blank');
          } else {
            window.open(`https://dashboard.stripe.com/test/payments/${pspPayment.additionalFields.STRIPE_PAYMENT_INTENT_ID}`, '_blank');
          }
          break;
        case 'Mollie':
          window.open(`https://www.mollie.com/dashboard/payments/${pspPayment.externalPaymentId}`, '_blank');
          break;
        default:
      }
    },
    cancelPaymentRequest() {
      this.axios.delete(this.serviceUrls.paymentRequest.delete(this, this.paymentRequestId))
        .then((response) => {
          this.showSuccessMessage();
          this.updateData();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    markAsPaid() {
      this.axios.post(this.serviceUrls.paymentRequest.paid(this, this.paymentRequestId))
        .then((response) => {
          this.showSuccessMessage();
          this.updateData();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/reservation/PagePaymentRequest.vue